import * as React from "react";
import { AirMeltAlloy } from "../schema-types";

require("../../styles/shared-styles.scss");

interface AirMeltTableRowProps {
  product: AirMeltAlloy;
}

export class AirMeltTableRowUI extends React.PureComponent<
  AirMeltTableRowProps,
  {}
> {
  render() {
    const p = this.props.product;

    let tableHeaderClassNames = "table-row";

    let fullRow = (
      <div className={tableHeaderClassNames}>
        <div className="category-col">{placeholderIfEmpty(p.category, 35)}</div>
        <div className="cm-name-col">
          {placeholderIfEmpty(p.cannonMuskegonTitle, 11)}
        </div>
        <div className="common-name-col">
          {placeholderIfEmpty(p.commonName, 12)}
        </div>
        <div className="trade-name-col">{placeholderIfEmpty(p.tradeName)}</div>
        <div className="astm-col">{placeholderIfEmpty(p.astm, 7)}</div>
        <div className="asm-col">
          {placeholderIfEmpty(p.aerospaceMaterialSpecifications, 5)}
        </div>
        <div className="uns-col">{placeholderIfEmpty(p.uns)}</div>
        <div className="din-col">{placeholderIfEmpty(p.din, 7)}</div>
        <div className="wnr-col">{placeholderIfEmpty(p.wNr, 7)}</div>
        <div className="afnor-col">{placeholderIfEmpty(p.afnor, 6)}</div>
        <div className="elemental-col">{p.carbon}</div>
        <div className="elemental-col">{p.manganese}</div>
        <div className="elemental-col">{p.silicon}</div>
        <div className="elemental-col">{p.chromium}</div>
        <div className="elemental-col">{balanceIfEmpty(p.nickel)}</div>
        <div className="elemental-col">{p.molybdenum}</div>
        <div className="elemental-col">{p.phosphorus}</div>
        <div className="elemental-col">{p.sulfur}</div>
        <div className="elemental-col">{p.vanadium}</div>
        <div className="elemental-col">{p.tungsten}</div>
        <div className="elemental-col">{balanceIfEmpty(p.cobalt)}</div>
        <div className="elemental-col">{p.copper}</div>
        <div className="elemental-col">{balanceIfEmpty(p.iron)}</div>
        <div className="physical-col">{placeholderIfEmpty(p.solidusF)}</div>
        <div className="physical-col">{placeholderIfEmpty(p.liquidousF)}</div>
        <div className="other-col">
          {p.other}
        </div>
      </div>
    );

    return fullRow;
  }
}

function placeholderIfEmpty(value: any, length: number = 9) {
  if (!value) {
    return "-";
  } else {
    return value;
  }
}

function balanceIfEmpty(value: number | null) {
  if (value != null) {
    return value;
  } else {
    return "Bal.";
  }
}
